module.exports = __webpack_public_path__ + "img/injectionsteps_step3.d4bfbbd9.png";